import axios from "axios";

import {
    API_USERS_ADMIN, API_USERS_ADMIN_SINGLE_LOGIN_HASH
} from "./API_CONSTANTS";

export const getUsersByAdmin = () => {
    return new Promise((resolve, reject) => {
        try {
            axios.get(API_USERS_ADMIN)
                .then((res) => {
                    console.log('Users loaded: ', res);
                    resolve(res.data);
                })
                .catch((err) => {
                    console.log('Get users error: ', err);
                    reject('Get users error');
                });
        } catch (error) {
            console.error('Get users error: ', error);
            reject('Get users error');
        }
    });
};

export const postUserByAdmin = (user) => {
    return new Promise((resolve, reject) => {
        try {
            axios.post(API_USERS_ADMIN, user)
                .then((res) => {
                    console.log("user created: ", res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    console.log("user creation error: ", err);
                    reject("user creation error!");
                });
        } catch (error) {
            reject("user creation error!");
        }
    });
}

export const getUserByAdmin = (userId) => {
    const url = API_USERS_ADMIN + '/' + userId;
    return new Promise((resolve, reject) => {
        try {
            axios.get(url)
                .then((res) => {
                    console.log("User loaded: ", res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    console.log("Get user error: ", err);
                    reject("Get user error!");
                });
        } catch (error) {
            reject("Get user error!");
        }
    });
}


export const updateUserByAdmin = (user) => {
    const url = API_USERS_ADMIN + '/' + user.id;
    return new Promise((resolve, reject) => {
        try {
            axios.put(url, user, {
                headers: {
                    "content-type": "application/json"
                }
            })
                .then((res) => {
                    console.log("user data updated: ", res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    console.log("user update error: ", err);
                    reject("user update error!");
                });
        } catch (error) {
            reject("user update error!");
        }
    });
}


export const removeUserByAdmin = (user) => {
    const url = API_USERS_ADMIN + '/' + user.id;

    return new Promise((resolve, reject) => {
        try {
            axios.delete(url)
                .then((res) => {
                    console.log('User removed by admin: ', res);
                    resolve(res);
                })
                .catch((err) => {
                    console.log('Remove user by admin error: ', err);
                    reject('Remove user by admin error');
                });
        } catch (error) {
            console.error('Remove user by admin error: ', error);
            reject('Remove user by admin error');
        }
    });
}


export const setSingleLoginButton = (userId) => {
    return new Promise((resolve, reject) => {
        try {
            axios.post(API_USERS_ADMIN_SINGLE_LOGIN_HASH, { user_id: userId })
                .then((res) => {
                    console.log("Set single login button: ", res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    console.log("Single login button error: ", err);
                    reject("Single login button error!");
                });
        } catch (error) {
            reject("Single login button error!");
        }
    });
}

export const clearSingleLoginButton = (userId) => {
    return new Promise((resolve, reject) => {
        try {
            axios.delete(API_USERS_ADMIN_SINGLE_LOGIN_HASH, { data: { user_id: userId } })
                .then((res) => {
                    console.log("Clear single login button: ", res.data);
                    resolve(res.data);
                })
                .catch((err) => {
                    console.log("Clear single login button error: ", err);
                    reject("Clear single login button error!");
                });
        } catch (error) {
            reject("Clear single login button error!");
        }
    });
}
